<template>
  <div class="authorized-layout">
    <NavBarComponent />
    <slot />
  </div>
</template>

<script>
import NavBarComponent from "@/components/NavBar";
export default {
  name: "Authorized",
  components: {
    NavBarComponent
  }
};
</script>

<style lang="scss" scoped></style>
